import Raact, { Component } from 'react';

class Animals extends Component {

  render() {
    const { pets } = this.props;

    return (
      <div className='pets-wrapper container-fluid d-flex justify-content-evenly flex-wrap'>
        {pets.map(pet => {
          const { id, name, age, gender, species, photos, url, description } = pet;

          // Decoding HTML entities from string
          function decode(str) {
            let txt = document.createElement('textarea');
            txt.innerHTML = str;
            return txt.value;
          }

          return (
            <div className='card m-2 h-100' key={id}>
              <img src={photos[0] ? photos[0].medium : './no-photo.svg'} className='card-img-top' alt={name} />
              <div className="card-body">
                <h5 className='card-title'>{name}</h5>
                <p className='card-text'>{age}, {species}, {gender}</p>
                {/* Double decoding because the source is doubel encoded */}
                <p className='card-text'>{decode(decode(description))}</p>
              </div>
              <div className="card-footer text-body-secondary text-center">
                <a href={url} target='_blank' className='btn btn-outline-primary'>{name}'s page</a>
              </div>
            </div>
          )

        })
        }
      </div>
    );
  }
}

export default Animals;